export type TagCategory = "execview" | "p2" | "reporting" | "other";

// Spatial tags are grouped by prefix so each category can be coloured
// distinctly in the configuration tree. Everything that isn't an execview,
// p2/phase, or reporting tag (floor, B, ss, metadata, ...) falls back to
// "other" and renders in a neutral grey.
export const getTagCategory = (text: string): TagCategory => {
  const value = text.trim().toLowerCase();
  if (value.startsWith("execview")) {
    return "execview";
  }
  if (value.startsWith("p2")) {
    return "p2";
  }
  if (value.startsWith("reporting")) {
    return "reporting";
  }
  return "other";
};
